<template>

<app-view-list-field :is-condensed="isCondensed" :is-sticky="isSticky" :field="field" :filter="filter">

    <core-gamename :game="item.game" class="game-name" />

	<app-view-common-insight_play-tags :item="item" :field="field" v-if="field.status === 'enabled'" />

	<div class="game-version" v-if="showLocation">{{ item.play.location }}</div> 

	<app-view-common-insight_play-players :item="item" :inline="true" :field="field" v-if="field.players === 'enabled'" />

    <app-view-common-tags :field="field" :item="item" :filter="filter" :is-condensed="isCondensed" v-if="showTags" />

    <div class="card-body-comment" v-if="showReport && item.play.comment">

		<div ref="comment" v-html="this.item.play.comment"></div>

		<div class="card-body-comment-fade" v-if="longComment"></div>

	</div>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'item', 'filter', 'isCondensed', 'isSticky'],

	data: function() {

		return {

			longComment: false

		}

	},

	watch: {

        longComment: function(n) {

            this.$emit('longcomment', n)

        },

		ready: function(n) {

			if (n) this.checkComment()

		},

		window: {

			handler: function(n, o) {

				if (n.width !== o.width) {

					this.checkComment()

				}

			},

			deep: true

		}

	},

	mounted: function() {

		this.checkComment()

	},

	computed: {

        showLocation: function() {

            return this.field.location === 'enabled'

        },

        showReport: function() {

            return this.field.report === 'enabled'

        },

        showTags: function() {

            return this.field.tags === 'enabled'

        }

    },

	methods: {

		checkComment: function() {

            if (this.$isDesktop) return

			if (this.item.comment) {

				this.$nextTick(function() {
					if (this.$refs.comment) this.longComment = this.$refs.comment.offsetHeight > 90
				}.bind(this))

			}

		}

    }

}

</script>

<style scoped>

.game-name {
	color: #333;
	font-weight: 500;
	font-size: 16px;
	line-height: 16px;
    display: block;
    cursor: pointer;
    overflow: hidden;
}

.is-desktop .game-name {
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
	min-width: 0;
}

.is-mobile .game-name {
	font-size: 14px;
	line-height: 14px;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;   
  	overflow: hidden;
  	word-break: break-word;
}

.field.is-condensed .game-name {
	font-size: 14px;
	line-height: 14px;
}

.is-mobile .field.is-condensed .game-name {
	font-size: 12px;
	line-height: 12px;
}

.is-desktop .game-name:hover {
	text-decoration: underline;
}

.game-version {
	color: #666;
	font-size: 11px;
	margin-top: 2px;
	line-height: 11px;
	font-weight: 400;
}

.is-mobile .game-version {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;   
  	overflow: hidden;
	margin-top: 0px;
  	word-break: break-word;
}

.card-body-comment {
	font-size: 14px;
	color: #666;
	line-height: 18px;
    margin-top: 5px;
    background-color: #f7f7f7;
    padding: 10px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 14px;
}

.is-mobile .card-body-comment {
	font-size: 14px;
	line-height: 16px;
}	

.card-body-comment.is-empty {
	opacity: 0.6;
}

.card-body-comment.is-empty:before {
	content: 'No comment written.'
}

.card-body-comment-fade {
	position: absolute; 
	bottom: 0; 
	left: 0;
	width: 100%; 
	text-align: center; 
	margin: 0; padding: 30px 0; 
	background-image: linear-gradient(to bottom, transparent, #fff);
}

.card.is-selected .card-body-comment-fade {
	background-image: linear-gradient(to bottom, transparent, #d4f2ff);
}

.card-body-comment-info {
	display: flex;
	flex-direction: row;
	margin-top: 10px;
}

.card-body-comment-info-date {
	font-size: 11px;
	font-weight: 300;
	color: #c7c7c7;
	flex-grow: 1;
}

.card-body-comment-info-more {
	flex-grow: 0;
	font-size: 12px;
	color: #4881bb;
	font-weight: 400;
	cursor: pointer;
}

.is-desktop .card-body-comment-info-more:hover {
	text-decoration: underline;
}

</style>